import React from 'react';
import { Box, Typography, Paper, Container, Divider, List, ListItem, ListItemText } from '@mui/material';

export const PrivacyPage: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Box sx={{ py: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          Privacy Policy & Confidentiality
        </Typography>
        
        <Paper sx={{ p: 4, mt: 3 }}>
          <Typography variant="h5" gutterBottom>
            Last Updated: {new Date().toLocaleDateString()}
          </Typography>
          
          <Divider sx={{ my: 3 }} />
          
          <Typography variant="h6" gutterBottom>
            1. Information We Collect
          </Typography>
          <Typography variant="body1" paragraph>
            We collect information you provide directly to us, such as when you create an account, 
            participate in matches or tournaments, or contact us for support. This may include:
          </Typography>
          <List>
            <ListItem>
              <ListItemText 
                primary="• Personal identification information (name, email address, phone number)"
                secondary="Used for account creation and communication"
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="• Profile information (age, skill level, preferences)"
                secondary="Used to match you with appropriate players and tournaments"
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="• Match and tournament data (scores, results, statistics)"
                secondary="Used to track your performance and provide statistics"
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="• Usage data (app interactions, features used)"
                secondary="Used to improve our services and user experience"
              />
            </ListItem>
          </List>

          <Divider sx={{ my: 3 }} />
          
          <Typography variant="h6" gutterBottom>
            2. How We Use Your Information
          </Typography>
          <Typography variant="body1" paragraph>
            We use the information we collect to:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="• Provide, maintain, and improve our services" />
            </ListItem>
            <ListItem>
              <ListItemText primary="• Process and manage your account and participation in matches/tournaments" />
            </ListItem>
            <ListItem>
              <ListItemText primary="• Send you technical notices, updates, and support messages" />
            </ListItem>
            <ListItem>
              <ListItemText primary="• Respond to your comments, questions, and customer service requests" />
            </ListItem>
            <ListItem>
              <ListItemText primary="• Monitor and analyze trends, usage, and activities in connection with our services" />
            </ListItem>
          </List>

          <Divider sx={{ my: 3 }} />
          
          <Typography variant="h6" gutterBottom>
            3. Information Sharing and Disclosure
          </Typography>
          <Typography variant="body1" paragraph>
            We do not sell, trade, or otherwise transfer your personal information to third parties 
            without your consent, except in the following circumstances:
          </Typography>
          <List>
            <ListItem>
              <ListItemText 
                primary="• Service Providers"
                secondary="We may share information with trusted third-party service providers who assist us in operating our platform"
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="• Legal Requirements"
                secondary="We may disclose information if required by law or to protect our rights and safety"
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="• Business Transfers"
                secondary="In the event of a merger, acquisition, or sale of assets, your information may be transferred"
              />
            </ListItem>
          </List>

          <Divider sx={{ my: 3 }} />
          
          <Typography variant="h6" gutterBottom>
            4. Data Security
          </Typography>
          <Typography variant="body1" paragraph>
            We implement appropriate technical and organizational security measures to protect 
            your personal information against unauthorized access, alteration, disclosure, or destruction. 
            However, no method of transmission over the internet or electronic storage is 100% secure, 
            so we cannot guarantee absolute security.
          </Typography>

          <Divider sx={{ my: 3 }} />
          
          <Typography variant="h6" gutterBottom>
            5. Your Rights and Choices
          </Typography>
          <Typography variant="body1" paragraph>
            You have the right to:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="• Access and update your personal information" />
            </ListItem>
            <ListItem>
              <ListItemText primary="• Request deletion of your account and associated data" />
            </ListItem>
            <ListItem>
              <ListItemText primary="• Opt-out of certain communications" />
            </ListItem>
            <ListItem>
              <ListItemText primary="• Request a copy of your personal data" />
            </ListItem>
          </List>

          <Divider sx={{ my: 3 }} />
          
          <Typography variant="h6" gutterBottom>
            6. Data Retention
          </Typography>
          <Typography variant="body1" paragraph>
            We retain your personal information for as long as necessary to provide our services 
            and fulfill the purposes outlined in this privacy policy. When you delete your account, 
            we will delete or anonymize your personal information, except where we are required 
            to retain it for legal or legitimate business purposes.
          </Typography>

          <Divider sx={{ my: 3 }} />
          
          <Typography variant="h6" gutterBottom>
            7. Children's Privacy
          </Typography>
          <Typography variant="body1" paragraph>
            Our services are not intended for children under the age of 13. We do not knowingly 
            collect personal information from children under 13. If you are a parent or guardian 
            and believe your child has provided us with personal information, please contact us.
          </Typography>

          <Divider sx={{ my: 3 }} />
          
          <Typography variant="h6" gutterBottom>
            8. Changes to This Policy
          </Typography>
          <Typography variant="body1" paragraph>
            We may update this privacy policy from time to time. We will notify you of any changes 
            by posting the new privacy policy on this page and updating the "Last Updated" date. 
            We encourage you to review this privacy policy periodically.
          </Typography>

          <Divider sx={{ my: 3 }} />
          
          <Typography variant="h6" gutterBottom>
            9. Contact Us
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about this privacy policy or our data practices, 
            please contact us:
          </Typography>
          <Typography variant="body1" paragraph>
            privacy@padpal.fr
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};
